import { render, staticRenderFns } from "./OldBrowserWarning.vue?vue&type=template&id=4bb3e1b1"
import script from "./OldBrowserWarning.vue?vue&type=script&lang=js"
export * from "./OldBrowserWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports